import { render, staticRenderFns } from "./AboutVisionPage.vue?vue&type=template&id=40a57bc9&scoped=true"
import script from "./AboutVisionPage.vue?vue&type=script&lang=js"
export * from "./AboutVisionPage.vue?vue&type=script&lang=js"
import style0 from "./AboutVisionPage.vue?vue&type=style&index=0&id=40a57bc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a57bc9",
  null
  
)

export default component.exports